module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/appeal_top_sub_02-d10dad00eda835e5303471078a6c31bc.jpg";